/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  PostTournamentsIdCancelMutationResponse,
  PostTournamentsIdCancelPathParams,
} from "../types/PostTournamentsIdCancel.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postTournamentsIdCancelMutationKey = () =>
  [{ url: "/tournaments/:id/cancel" }] as const;

export type PostTournamentsIdCancelMutationKey = ReturnType<
  typeof postTournamentsIdCancelMutationKey
>;

/**
 * @summary Отменить турнир (для организаторов)
 * {@link /tournaments/:id/cancel}
 */
export async function postTournamentsIdCancel(
  id: PostTournamentsIdCancelPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostTournamentsIdCancelMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "POST", url: `/tournaments/${id}/cancel`, ...requestConfig });
  return res;
}

export function postTournamentsIdCancelMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const mutationKey = postTournamentsIdCancelMutationKey();
  return mutationOptions<
    ResponseConfig<PostTournamentsIdCancelMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: PostTournamentsIdCancelPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return postTournamentsIdCancel(id, config);
    },
  });
}

/**
 * @summary Отменить турнир (для организаторов)
 * {@link /tournaments/:id/cancel}
 */
export function usePostTournamentsIdCancel<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PostTournamentsIdCancelMutationResponse>,
      ResponseErrorConfig<Error>,
      { id: PostTournamentsIdCancelPathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postTournamentsIdCancelMutationKey();

  const baseOptions = postTournamentsIdCancelMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<PostTournamentsIdCancelMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: PostTournamentsIdCancelPathParams["id"] },
    TContext
  >;

  return useMutation<
    ResponseConfig<PostTournamentsIdCancelMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: PostTournamentsIdCancelPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<PostTournamentsIdCancelMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: PostTournamentsIdCancelPathParams["id"] },
    TContext
  >;
}
